import { render, staticRenderFns } from "./PagamentoNotaFiscalVisualizarAnexo.vue?vue&type=template&id=2f47aa53&scoped=true"
import script from "./PagamentoNotaFiscalVisualizarAnexo.vue?vue&type=script&lang=js"
export * from "./PagamentoNotaFiscalVisualizarAnexo.vue?vue&type=script&lang=js"
import style0 from "./PagamentoNotaFiscalVisualizarAnexo.vue?vue&type=style&index=0&id=2f47aa53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f47aa53",
  null
  
)

export default component.exports